import { Calendar, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const MEETING_LINK = "https://calendar.app.google/gbZSzz4TiFAYYSjL8";

export function SignUpButton({ className, variant = "default", size = "default" }) {
  const handleClick = () => {
    window.open(MEETING_LINK, "_blank");
  };

  return (
    <Button
      onClick={handleClick}
      variant={variant}
      size={size}
      className={cn(
        variant === "default" 
          ? "bg-gradient-to-r from-violet-600 to-purple-600 hover:from-violet-700 hover:to-purple-700 text-white"
          : "",
        className
      )}
    >
      <Calendar className="w-4 h-4 mr-2" />
      Sign Up
      <ExternalLink className="w-3 h-3 ml-2" />
    </Button>
  );
}

export function SignUpBanner({ className }) {
  const handleClick = () => {
    window.open(MEETING_LINK, "_blank");
  };

  return (
    <div 
      className={cn(
        "bg-gradient-to-r from-violet-600/20 to-purple-600/20 border border-violet-500/30 rounded-xl p-4 cursor-pointer hover:border-violet-500/50 transition-all",
        className
      )}
      onClick={handleClick}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-violet-500/20 flex items-center justify-center">
            <Calendar className="w-5 h-5 text-violet-400" />
          </div>
          <div>
            <p className="text-white font-semibold">Ready to get started?</p>
            <p className="text-zinc-400 text-sm">Schedule a call with our team</p>
          </div>
        </div>
        <Button 
          size="sm"
          className="bg-violet-600 text-white hover:bg-violet-700"
        >
          Sign Up
          <ExternalLink className="w-3 h-3 ml-2" />
        </Button>
      </div>
    </div>
  );
}
